import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { CheckCircle2, XCircle, AlertCircle } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider duration={8000}>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const isSuccess = variant === "success"
        const isDestructive = variant === "destructive"
        
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start gap-3">
              {isSuccess ? (
                <div className="h-6 w-6 rounded-full bg-brand-teal/20 flex items-center justify-center shrink-0">
                  <CheckCircle2 className="h-4 w-4 text-brand-teal" />
                </div>
              ) : isDestructive ? (
                <div className="h-6 w-6 rounded-full bg-red-500/20 flex items-center justify-center shrink-0">
                  <XCircle className="h-4 w-4 text-red-600" />
                </div>
              ) : (
                <div className="h-6 w-6 rounded-full bg-brand-teal/20 flex items-center justify-center shrink-0">
                  <AlertCircle className="h-4 w-4 text-brand-teal" />
                </div>
              )}
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
